import './App.css';
import React, {useEffect, useState} from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import LoginPage from './components/login/login-page';
import OtpLogin from './components/otp-login/otp-login.js'
import { global_var } from "../src/services/login-config.js"
import { getCompanyDetails, userTokenAuthentication } from "../src/services/login-api.js";
import CsproLogin from './components/login/cspro_login';
import GoogleSignIn from './components/login/google_sign_in';
import { Spin } from 'antd';
import BrowserDetectionModal from './components/modal/browserDetection-modal.js'
import ProfileSetup from './components/profile-setup/profile-setup.js';

function App() {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [companyName, setCompanyName] = useState('')
  const [favIcon, setFavicon] = useState(null)

  useEffect(() => {
    
    const isChromium = window.chrome;
    const winNav = window.navigator;
    const vendorName = winNav.vendor;
    const isOpera = typeof window.opr !== "undefined";
    const isIEedge = winNav.userAgent.indexOf("Edg") > -1;
    const isIOSChrome = winNav.userAgent.match("CriOS");
    const isSafari = /^((?!chrome|android).)*safari/i.test(winNav.userAgent);


    if (!(isSafari || isIOSChrome || (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false))) {
      setShowModal(true);
    }

    const logout = new URLSearchParams(window.location.search).get('logout');
    if(logout? logout === 'true': false) {
      localStorage.removeItem('token');
    } else {
      const token = localStorage.getItem('token');
      if(token) {
        userTokenAuthentication(token).then((response)=>{

          if(response.statusCode === 200) {
            let domainName = 'https://' + window.location.host.replace(/.login/g,'');
              if (response.userDetails.roleId === '3' || response.userDetails.roleName ===  "Mentee") {
                domainName += '/candidate/#/home/redirect';
              } else {
                domainName += '/company/#/home/redirect';
              }
              domainName += '?access_token=' + token;

              if(global_var.dashboard_url && response.userDetails? response.userDetails.roleId? response.userDetails.roleId !== '3': false  : false){
                domainName = 'https://' + global_var.dashboard_url + '?token=' + token;
              }
              window.location.href = domainName;
          } else{
            localStorage.removeItem('token');
          }
        })
      }
    }

    if (window.location.host.split(".").length > 2) {
      let domainName = window.location.host.split('.')[0];
      getCompanyDetails(domainName).then((response) => {
        setLoading(false);
        const data = JSON.parse(response);
        global_var.companyId = data.companyId['$oid'];
        global_var.company_name = data.companyName;
        setCompanyName(global_var.company_name)
        global_var.domain_name = window.location.hostname;
        if(data.dashboardUrl){
          global_var.dashboard_url = data.dashboardUrl;
        }
        
        if (data.appSettings ? data.appSettings.favicon: false) {
          setFavicon(data.appSettings.favicon)
        }

        if(data.appSettings? data.appSettings.logo: false) {
          const redirectionUrl = 'https://services.baabtra.com/files/';
          const s3FileUploadUrl = 'https://99lmsfileuploadfolder.s3.ap-south-1.amazonaws.com/uploaded/';
          if (data.appSettings.logo.includes(redirectionUrl)) {
            data.appSettings.logo = data.appSettings.logo.replace(redirectionUrl, s3FileUploadUrl);
        }
        global_var.logo = data.appSettings.logo;
        
        }
      });
    }
  },[])

  useEffect(() => {
    document.title = companyName
    if (favIcon) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = favIcon;
      document.head.appendChild(link);
    }
    
  }, [companyName, favIcon]);

  return (
    <BrowserRouter>
      {loading? (
        <div className="spinner-container">
          <Spin size="large" />
      </div>
      ) :showModal?(<>
          <BrowserDetectionModal />
        </>)
      : (
        <>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/otpLogin" element={ <OtpLogin />} />
            <Route path="*" element={<Navigate to="/login" />} />
            <Route path="/cspro_login" element={<CsproLogin />} />
            <Route path="/google_sign" element={<GoogleSignIn />} />
            <Route path="/profile-setup" element={<ProfileSetup/>}/>
            {/* Add other routes as needed */}
          </Routes>
        </>
      )}
    </BrowserRouter>
  );
}

export default App;
